import { createRouter, createWebHistory } from 'vue-router'
import Index from '../views/IndexView.vue'
import Location from '../views/LocationView.vue'
import Locale from '../views/LocaleView.vue'
import Order from '../views/OrderView.vue'
import Rank from '../views/RankView.vue'
import Sign from '../views/SignView.vue'
import Success from '../views/SuccessView.vue'

const appname = '智能救援管理平台'

const routes = [
  {
    path: '/:id?',
    name: 'Index',
    component: Index,
    meta: { title: appname }
  },
  {
    path: '/order/:id',
    name: 'Order',
    component: Order,
    meta: { title: `电子工单 - ${appname}` }
  },
  {
    path: '/sign/:role/:id',
    name: 'Sign',
    component: Sign,
    meta: { title: `客户签名 - ${appname}` }
  },
  {
    path: '/success/:id',
    name: 'Success',
    component: Success,
    meta: { title: `提示 - ${appname}` }
  },
  {
    path: '/location/:id',
    name: 'Location',
    component: Location,
    meta: { title: `上报定位 - ${appname}` }
  },
  {
    path: '/locale/:id', 
    name: 'Locale',
    component: Locale,
    meta: { title: `现场照片 - ${appname}` }
  },
  
  {
    path: '/rank/:id',
    name: 'Rank',
    component: Rank,
    meta: { title: `客户评价 - ${appname}` }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
